// src/components/dashboard/SystemHealthBlock.jsx — v8.7.4
// MICRO-TUNING: лёгкий зелёный border при system_status="operational"
// Это даёт низу дашборда визуальный акцент — не сухой блок
// padding ячеек 12px (было 18→12 в v873)
// Telegram DISABLED когда токен не настроен

import Panel        from "../ui/Panel";
import SectionTitle from "../ui/SectionTitle";

const ITEMS = [
  { label: "Backend",  key: "backend_ok" },
  { label: "Database", key: "d1_ok" },
  { label: "Writer",   key: "writer_ok" },
  { label: "Cron",     key: "cron_ok" },
  { label: "Telegram", key: "telegram_ok" },
  { label: "Data",     key: "data_consistency_ok" },
];

const statusColors = {
  operational: "var(--success)",
  warning:     "var(--warning)",
  degraded:    "var(--warning)",
  down:        "var(--danger)",
};

// Цвет border панели по system_status
function panelBorder(status) {
  switch (status) {
    case "operational": return "rgba(16,217,126,0.25)";  // лёгкий зелёный
    case "warning":
    case "degraded":    return "rgba(245,166,35,0.25)";
    case "down":        return "rgba(240,64,64,0.3)";
    default:            return "var(--border-subtle)";
  }
}

function getDisplay(key, val, health) {
  if (key === "telegram_ok") {
    if (!val && !health?.telegram_token_present)
      return { label: "DISABLED", color: "var(--text-muted)", dot: "var(--text-muted)", glow: false };
    if (!val)
      return { label: "WARN", color: "var(--warning)", dot: "var(--warning)", glow: false };
    return { label: "OK", color: "var(--success)", dot: "var(--success)", glow: true };
  }
  const isOk  = val === true || val === 1 || val === "ok";
  const color = val == null ? "var(--text-muted)" : isOk ? "var(--success)" : "var(--danger)";
  return { label: val == null ? "—" : isOk ? "OK" : "ERR", color, dot: color, glow: isOk };
}

export default function SystemHealthBlock({ health }) {
  const statusColor = statusColors[health?.system_status] ?? "var(--text-tertiary)";
  const score = typeof health?.health_score === "number" ? Math.round(health.health_score) : null;

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
        <SectionTitle title="System Health" />
        {health?.system_status && (
          <span style={{ fontFamily: "var(--font-mono)", fontSize: 10, color: statusColor, letterSpacing: "0.1em" }}>
            {health.system_status.toUpperCase()}{score != null ? ` · ${score}%` : ""}
          </span>
        )}
      </div>

      <Panel style={{
        padding: 0,
        // MICRO-TUNING: цветной border по статусу системы
        border: `1px solid ${panelBorder(health?.system_status)}`,
      }}>
        {!health ? (
          <div style={{ padding: 16, fontFamily: "var(--font-mono)", fontSize: 12, color: "var(--text-muted)" }}>
            Loading health data...
          </div>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(6,1fr)" }}>
            {ITEMS.map((item, i) => {
              const d = getDisplay(item.key, health[item.key], health);
              return (
                <div key={item.key} style={{
                  padding: "12px 14px",
                  borderRight: i < ITEMS.length - 1 ? "1px solid var(--border-subtle)" : "none",
                  display: "flex", flexDirection: "column", gap: 6, alignItems: "center",
                }}>
                  <div style={{
                    width: 7, height: 7, borderRadius: "50%",
                    background: d.dot,
                    boxShadow: d.glow ? `0 0 7px ${d.dot}` : "none",
                  }} />
                  <div style={{ fontFamily: "var(--font-mono)", fontSize: 9, letterSpacing: "0.12em", textTransform: "uppercase", color: "var(--text-tertiary)" }}>
                    {item.label}
                  </div>
                  <div style={{ fontFamily: "var(--font-mono)", fontSize: 11, fontWeight: 700, color: d.color }}>
                    {d.label}
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {health && (health.errors_24h > 0 || health.warnings_24h > 0) && (
          <div style={{ padding: "8px 14px", borderTop: "1px solid var(--border-subtle)", display: "flex", gap: 16 }}>
            {health.errors_24h > 0 && (
              <span style={{ fontFamily: "var(--font-mono)", fontSize: 10, color: "var(--danger)" }}>
                {health.errors_24h} errors (24h)
              </span>
            )}
            {health.warnings_24h > 0 && (
              <span style={{ fontFamily: "var(--font-mono)", fontSize: 10, color: "var(--warning)" }}>
                {health.warnings_24h} warnings (24h)
              </span>
            )}
          </div>
        )}
      </Panel>
    </div>
  );
}
